import './Card.css';

const Backing = (props) => {
    if (props.products === 'Coasters') {
        return <div className="cork"></div>;
    }

    if (props.products === 'Magnets') {
        return <div className="magnet"></div>;
    }

    if (props.products === 'Bookmarks') {
        return <div className="bookmark"></div>;
    }

    if (props.products === 'Greeting Cards') {
        return <div className="greeting_cards"></div>;
    }
};

export default Backing;
